/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
import UCheckboxList from '@ultra/share/components/UCheckboxList/index.vue';
import { apiAdminGetGameList } from '@/api/user';
export default /*#__PURE__*/_defineComponent({
  props: {
    userId: {
      type: Number,
      default: undefined
    },
    type: {
      type: String,
      default: ''
    }
  },
  emits: ['change'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const loadingGame = ref(false);
    const gameList = ref([]);
    const gameIds = ref([]);
    const getData = () => {
      loadingGame.value = true;
      apiAdminGetGameList({
        UserId: props.userId
      }).then(res => {
        if (res.code === 0) {
          res.data.length && res.data.forEach(item => {
            item.Highlight = false;
          });
          gameList.value = res.data;
          res.data.length && res.data.forEach(item => {
            if (item.Checked) {
              gameIds.value.push(item.Id);
            }
          });
          changeGame(gameIds.value);
        }
      }).finally(() => {
        loadingGame.value = false;
      });
    };
    const changeGame = val => {
      let all = val.length > 0 && val.length === gameList.value.length;
      emits('change', val, all);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _directive_loading = __unplugin_directives_0;
      return _withDirectives((_openBlock(), _createElementBlock("div", null, [_createVNode(UCheckboxList, {
        data: gameList.value,
        modelValue: gameIds.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => gameIds.value = $event),
        keyword: "Id",
        label: "Name",
        onChange: changeGame,
        disabled: __props.type === 'check'
      }, null, 8, ["data", "modelValue", "disabled"])])), [[_directive_loading, loadingGame.value]]);
    };
  }
});